$(function()
{
  	/* fixed header */
  	var scrolled_from_top = $(window).scrollTop(),
        motivator_bar_height = $('#motivatorBar').height(),
        site_header = $('.site-header');
  	
  	/*window.onscroll = function()
	{
		if(window.pageYOffset >= motivator_bar_height && !site_header.hasClass('fixed'))
		{
			site_header.addClass('fixed');
          	
            if($('#productNavList').length > 0)
            {
                $('#productNavList').css({'position': 'fixed', 'top': '64px', 'width': '100%'});
            }
		}
		else if(window.pageYOffset < motivator_bar_height && site_header.hasClass('fixed'))
		{
			site_header.removeClass('fixed');
          	
            if($('#productNavList').length > 0)
            {
                $('#productNavList').css({'position': 'static', 'top': 'auto'});
            }
		}
    };*/
  
  	$(window).on('scroll', _.throttle(function()
    {
        if(window.pageYOffset >= motivator_bar_height && !site_header.hasClass('fixed'))
		{
			site_header.addClass('fixed');
          	
            if($('#productNavList').length > 0)
            {
                $('#productNavList').css({'position': 'fixed', 'top': '64px', 'width': '100%'});
            }
		}
		else if(window.pageYOffset < motivator_bar_height && site_header.hasClass('fixed'))
		{
			site_header.removeClass('fixed');
          	
            if($('#productNavList').length > 0)
            {
                $('#productNavList').css({'position': 'static', 'top': 'auto'});
            }
		}
    }, 250));

	/* Js for Flag */
	$('.lang-menu').click(function() { 
        if( $('.country-ul').hasClass("active")){
          $('.country-ul').removeClass('active');
        }else{
          $('.country-ul').addClass('active');
        }
    });

	//Language dropdown for mobile
	$('.lang-menu-mobile').click(function() { 
			if( $('.country-ul-mobile').hasClass("active")){
			$('.country-ul-mobile').removeClass('active');
			}else{
			$('.country-ul-mobile').addClass('active');
			}
		});

	$('.country-change-btn').click(function () {
		let countryCode = $(this).attr("data-code");
		//let imageUrl = $(this).attr("data-imageurl");
		$("input[name='country_code']").val(countryCode);
		//$('.flag-image').css('backgroundImage','url('+imageUrl+')');
		$("#language_form").submit()
	})
});